<div class="landing-container">
  @if (successMessages.length > 0) {
    <div class="success-section">
      <ul class="message-list">
        @for (msg of successMessages; track $index) {
          <li>
            <mat-icon class="success-icon">done</mat-icon>
            <span class="message-text"
              >{{ msg }} - {{ 'Joined successfully' | translate }}
            </span>
          </li>
        }
      </ul>
    </div>
  }

  @if (
    errorMessages.length > 0 ||
    limitMessages.length > 0 ||
    daylimitMessages.length > 0
  ) {
    <div class="error-section">
      <ul class="message-list">
        @for (msg of errorMessages; track $index) {
          <li>
            <mat-icon class="error-icon">clear</mat-icon>
            <span class="message-text"
              >{{ msg }} — {{ 'Slot is full' | translate }}</span
            >
          </li>
        }
        @for (line of limitMessages; track $index) {
          <li>
            <mat-icon class="error-icon">clear</mat-icon>
            <span class="message-text"
              >{{ line.date }} — {{ (line.label ?? '') | translate }}</span
            >
          </li>
        }
        @for (line of daylimitMessages; track $index) {
          <li>
            <mat-icon class="error-icon">clear</mat-icon>
            <span class="message-text">
              {{ line.date }}
              @if (line.label) {
                — {{ line.label | translate }}
              }
            </span>
          </li>
        }
      </ul>
    </div>
  }

  <button mat-button class="home-btn" (click)="onRedirect()">
    {{ 'Go to My reservations' | translate }}
  </button>
</div>
